/**
 * 新規画面追加となる画面の表示文言のみリソース定義
 */

export const PageMessage = {
  'common.support-request.yes': '希望する',
  'common.support-request.no': '希望しない',
  'restart.description': [
    '一度トラブルが解消したなどでお車の場所や状況が変化されているお客さまは、はじめから入力をお選びください。',
    'ヘルプボタンからコールセンターへご連絡いただいた場合や一時的に画面を閉じていたなど、入力内容に変更の無いお客さまは続きから入力をお選びください。',
  ],
  'contractInformation.title': 'お客さま情報',
  'contractInformation.button': '確認画面へ',
  'contractInformation.description':
    'コールセンターやスタッフからのご連絡、ご契約の確認に必要なため、以下の情報を教えてください。',
  'contractInformation.JAFDescription': [
    '弊社はJAF(日本自動車連盟)との提携があり、',
    'JAF会員のお客さまには優先的にJAFを手配しています。',
  ],
  'contractInformation.JAFKsDescription': [
    'JAF(日本自動車連盟)との提携があり、',
    'JAF会員のお客さまには優先的にJAFを手配しています。',
  ],
  'contractInformation.JafMembershipSjDescription': [
    'JAFによるお運びの場合、搬送先まで会員様のご同行が必要になる可能性があります。',
    '会員確認が出来なかった場合、JAF手配困難な場合は、弊社提携の業者を手配します。',
  ],
  'contractInformation.JafMembershipSaficDescription': [
    'JAFによるお運びの場合、搬送先まで会員様のご同行が必要になる可能性があります。',
    '会員確認が出来なかった場合、JAF手配困難な場合は、弊社提携の業者を手配します。',
  ],
  'contractInformation.JafMembershipKsDescription': [
    'JAF会員の方がJAF手配を希望された場合は、一定の優遇サービスが適用されます。',
    'JAFによるお運びの場合、搬送先まで会員様のご同行が必要になる可能性があります。',
    '会員確認が出来なかった場合、JAF手配困難な場合は、提携の業者を手配します。',
  ],
  'serviceInformation.title': '移動・宿泊費用補償について',
  'serviceInformation.description': [
    'お車をお運びした場合に限り、トラブル現場から出発地、居住地または当面の目的地への移動費用や、ご帰宅が困難な場合の宿泊費用が補償される場合がございます。',
    '交通機関やタクシーなどをご利用の際は、領収書の取り置きをお願いいたします。',
  ],
  'serviceInformation.movingCostCompensation.header': '●移動費用補償',
  'serviceInformation.movingCostCompensation.transportation':
    '公共交通機関利用の場合',
  'serviceInformation.movingCostCompensation.transportationMaximum':
    '限度額：１名２万円まで',
  'serviceInformation.movingCostCompensation.taxi':
    'タクシー・レンタカー利用の場合',
  'serviceInformation.movingCostCompensation.taxiMaximum':
    '限度額：１台２万円まで',
  'serviceInformation.movingCostCompensation.comment': [
    '※お客さまのおかれた条件によっては、補償対象外となる場合がございます。',
    '※精算可否や精算方法については、後日担当部署よりご連絡いたします。',
  ],
  'serviceInformation.lodgingExpenseCompensation.header': '●宿泊費用補償',
  'serviceInformation.lodgingExpenseCompensation.description':
    '限度額：１泊１名１万円まで',
  'serviceInformation.lodgingExpenseCompensation.comment': [
    '※夜間等、代替の移動が困難な場合に限ります。',
    '※ホテルでの飲食代等は含まれません。',
    '※精算可否や精算方法については、後日担当部署よりご連絡いたします。',
  ],
  'maintenance.title': 'システムメンテナンス中',
  'maintenance.description': [
    '申し訳ありません。現在、システムメンテナンス中です。',
    'お電話での受付は可能ですので、お手数ですが、下のヘルプボタンよりご連絡ください。',
  ],
  'precautions.title': 'ご注意事項',
  'precautions.caption': '＜ご注意事項＞',
  // 'confirmation.jaf.cofirmation': 'JAF手配について', 2609対応時削除
  'contractInformation.designatePartnerDescription.close': [
    '原則として当社にて業者を手配いたします。',
    'お客さまご指定の業者での対応を希望される場合は、',
    '本項目を選択してください。',
  ],
  'contractInformation.designatePartnerDescription.open': [
    '確認のためご指定の業者へ連絡させていただきます。',
  ],
}
